import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './styles/styles.css';

import Navbar from './components/Navbar';
import Home from './components/Home';
import ProjectPage from './components/ProjectPage';
import Resume from './components/Resume';
import Digantha from './components/Digantha';
import Footer from './components/Footer';

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const targetId = location.hash.slice(1);
    const scrollTimer = window.setTimeout(() => {
      document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);

    return () => window.clearTimeout(scrollTimer);
  }, [location.pathname, location.hash]);

  return null;
}

function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToHash />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project/:id" element={<ProjectPage />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/digantha" element={<Digantha />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
